module.exports = __webpack_public_path__ + "img/Galibots_Logo.066fd43.jpg";